import {fsa, fsaPayload} from '../../../../../actions/helpers'

export const GENERATE_WORLDPAY_PAYPAGE_TOKEN = 'getting paypage id'
export const generateWorldpayPaypageToken = fsaPayload(GENERATE_WORLDPAY_PAYPAGE_TOKEN)

export const RESET_WORLDPAY_VALUES = 'reset worldpay paypage values'
export const resetWorldpayValues = fsa(RESET_WORLDPAY_VALUES)
